import { EventType } from "./EventType";

export class EventWithData {
    public eventType: EventType;
    public data: any;

    constructor(eventType: EventType, data: any){
        this.eventType = eventType;
        this.data = data;
    }
}